export default "/kiban/_next/static/images/17_6L_2-2-2_withBH_fullstack-67733c4fd448716c4e8806799c0f6e3f.png";